import React from 'react';
import { motion } from 'framer-motion';
import { FacebookIcon, InstagramIcon, LinkedinIcon, TwitterIcon, AtSignIcon } from 'lucide-react';
const Contact: React.FC = () => {
  return <div className="min-h-screen pt-32 pb-20" data-id="element-180">
      <section className="container mx-auto px-4 py-20" data-id="element-181">
        <div className="bg-[#121212] rounded-3xl overflow-hidden" data-id="element-182">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-183">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5
          }} className="h-[600px]" data-id="element-184">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/p4xmA955NgrYuGKYwWdBc8/Portfolio_Secondary_Image_.jpg" alt="Hassaan Basit" className="w-full h-full object-cover" data-id="element-185" />
            </motion.div>
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="p-8 md:p-12" data-id="element-186">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="text-3xl md:text-5xl font-bold mb-4 text-white" data-id="element-187">
                YOUR ALL-IN-ONE GROWTH PARTNER
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.4
            }} className="font-thin mb-8 text-white" data-id="element-188">
                Why waste time and money juggling multiple freelancers? I
                provide a complete, streamlined digital ecosystem without the
                high costs and headaches of a traditional agency. Book your
                discovery call to get started.
              </motion.p>
              <motion.form initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5,
              delay: 0.5
            }} className="space-y-6" data-id="element-189">
                <div className="grid grid-cols-2 gap-4" data-id="element-190">
                  <div data-id="element-191">
                    <label className="block text-[#39FF14] text-sm font-thin mb-2" data-id="element-192">
                      Name
                    </label>
                    <input type="text" className="w-full bg-[#1A1A1A] rounded-lg p-3 text-white" data-id="element-193" />
                  </div>
                  <div data-id="element-194">
                    <label className="block text-[#39FF14] text-sm font-thin mb-2" data-id="element-195">
                      Email
                    </label>
                    <input type="email" className="w-full bg-[#1A1A1A] rounded-lg p-3 text-white" data-id="element-196" />
                  </div>
                </div>
                <div data-id="element-197">
                  <label className="block text-[#39FF14] text-sm font-thin mb-2" data-id="element-198">
                    Service Needed?
                  </label>
                  <select className="w-full bg-[#1A1A1A] rounded-lg p-3 text-white" data-id="element-199">
                    <option data-id="element-200">The Full Digital Ecosystem Package</option>
                    <option data-id="element-201">Market Research Blueprint</option>
                    <option data-id="element-202">Brand Identity Kit</option>
                    <option data-id="element-203">WordPress Website Development</option>
                    <option data-id="element-204">LinkedIn Authority Builder</option>
                    <option data-id="element-205">Social Media Management & Ads</option>
                    <option data-id="element-206">Other</option>
                  </select>
                </div>
                <div data-id="element-207">
                  <label className="block text-[#39FF14] text-sm font-thin mb-2" data-id="element-208">
                    What Can I Help You With?
                  </label>
                  <textarea className="w-full bg-[#1A1A1A] rounded-lg p-3 text-white h-32" placeholder="Hello, I'd like to enquire about..." data-id="element-209"></textarea>
                </div>
                <button type="submit" className="border border-[#39FF14] text-[#39FF14] px-8 py-3 rounded-full hover:bg-[#39FF14] hover:text-black transition-all font-bold" data-id="element-210">
                  SEND MESSAGE
                </button>
              </motion.form>
            </motion.div>
          </div>
        </div>
      </section>
      <section className="container mx-auto px-4 py-10" data-id="element-211">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-212">
          <div data-id="element-213">
            <h2 className="text-2xl font-bold mb-4" data-id="element-214">Connect With Me</h2>
            <div className="flex space-x-4" data-id="element-215">
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-216">
                <FacebookIcon size={24} data-id="element-217" />
              </a>
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-218">
                <InstagramIcon size={24} data-id="element-219" />
              </a>
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-220">
                <LinkedinIcon size={24} data-id="element-221" />
              </a>
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-222">
                <TwitterIcon size={24} data-id="element-223" />
              </a>
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-224">
                <AtSignIcon size={24} data-id="element-225" />
              </a>
            </div>
          </div>
          <div className="mt-8 md:mt-0" data-id="element-226">
            <p className="font-thin" data-id="element-227">
              Email:{' '}
              <span className="font-normal" data-id="element-228">hassaanbasitali@gmail.com</span>
            </p>
            <p className="font-thin" data-id="element-229">
              Call Today: <span className="font-normal" data-id="element-230">+92 300 1181588</span>
            </p>
          </div>
        </div>
      </section>
    </div>;
};
export default Contact;